import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../../Icon';
import './style.scss';

const SellLabel = ({ className, data, limit = 0 }) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  const labels = limit > 0 ? data.slice(0, limit) : data;
  return (
    <ul className={cx('goods-ui-labels', className)} data-label-type="sell">
      {
        labels.map((label, index) => {
          const { tag, text } = label;
          const key = `goods-ui-sell-labels-${index}`;
          return (
            <li key={key}>
              {
                tag === 'confirmTimeTag' && <Icon name="thunder" className="icon-thunder" />
              }
              {text}
            </li>
          );
        })
      }
    </ul>
  );
};

SellLabel.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  limit: PropTypes.number
};

export default SellLabel;
